export default __webpack_public_path__ + "static/media/ride-history.f549fc76.svg";